// import { Modal, Table } from "react-bootstrap";
// import ReactLoading from "react-loading";
// import { SyncLoader } from "react-spinners";
// import { dateFormat } from "../../Helpers/Utils/Common";

// export default function SupplierPriceTable(props) {
//     // Group data by supplier, item, and price
//         const suppliers = {};
//         props.tableData?.forEach(item => {
//             // Check if supplier exists, if not, create an array
//             if (!suppliers[item.supplier]) {
//                 suppliers[item.supplier] = [];
//             }

//             // Find the index of the item in the supplier array
//             const supplierIndex = suppliers[item.supplier].findIndex(supplierItem => supplierItem.name === item.name);

//             // If item not found for supplier, add a new object to the array
//             if (supplierIndex === -1) {
//                 suppliers[item.supplier].push({
//                     name: item.name,
//                     [item.unit]: [{ date: item.added_on, price: item.price, item_name: item.name }]
//                 });
//             } else {
//                 // If item found, check if unit exists, if not, create a new array
//                 if (!suppliers[item.supplier][supplierIndex][item.unit]) {
//                     suppliers[item.supplier][supplierIndex][item.unit] = [];
//                 }

//                 // Push the new item to the corresponding unit array
//                 suppliers[item.supplier][supplierIndex][item.unit].push({ date: item.added_on, price: item.price, item_name: item.name });
//             }
//         });

//         console.log(suppliers);
    
//     return props.showLoader ? (
//         <div className="d-flex justify-content-center my-5">
//             <SyncLoader color="var(--primary-color)" size={15} />
//         </div>
//         ) : (
//             <div>
//                 {Object.keys(suppliers)?.map(supplier => (
//                     <div key={supplier}>
//                         <h6>{supplier}</h6>
//                         {suppliers[supplier]?.map(item => (
//                             <div key={item.name}>
//                                 {/* <h6>{item.name}</h6> */}
//                                 {Object.keys(item).map(unit => (
//                                     unit !== 'name' &&
//                                     <Table key={unit}>
//                                         <thead>
//                                             <tr>
//                                                 <th rowSpan="2">Unit</th>
//                                                 <th rowSpan="2">Date</th>
//                                                 {/* <th colSpan={item[unit].length}>Item Name</th> */}
//                                             </tr>
//                                             <tr>
//                                                 {item[unit].map((data, index) => (
//                                                     <th key={index}>{data.item_name}</th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {item[unit].map((data, index) => (
//                                                 <tr className="req-table-w-border-top" key={index}>
//                                                     {index === 0 && <td className="req-table-w-border-sides" rowSpan={item[unit].length}>{unit}</td>}
//                                                     <td className="req-table-w-border-sides">{dateFormat(data.date)}</td>
//                                                     {item[unit].map((itemData, dataIndex) => (
//                                                         <td className="req-table-w-border-sides" key={dataIndex}>{itemData.price}</td>
//                                                     ))}
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </Table>
//                                 ))}
//                             </div>
//                         ))}
//                     </div>
//                 ))}
//             </div>
//     );
// }

// CORRECT
// import { Modal, Table } from "react-bootstrap";
// import ReactLoading from "react-loading";
// import { SyncLoader } from "react-spinners";
// import { dateFormat } from "../../Helpers/Utils/Common";

// export default function SupplierPriceTable(props) {
//     // Group data by supplier, item, and price
//     const suppliers = {};
//     props.tableData?.forEach(item => {
//         if (!suppliers[item.supplier]) {
//             suppliers[item.supplier] = [];
//         }

//         const existingItem = suppliers[item.supplier].find(existingItem => existingItem.name === item.name);
//         if (existingItem) {
//             existingItem.data.push({ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name });
//         } else {
//             suppliers[item.supplier].push({
//                 name: item.name,
//                 data: [{ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name }]
//             });
//         }
//     });

//     return props.showLoader ? (
//         <div className="d-flex justify-content-center my-5">
//             <SyncLoader color="var(--primary-color)" size={15} />
//         </div>
//     ) : (
//         <div>
//             {Object.keys(suppliers)?.map(supplier => (
//                 <div key={supplier}>
//                     <h6>{supplier}</h6>
//                     {suppliers[supplier]?.map((item, index) => (
//                         <div key={index}>
//                             <Table>
//                                 <thead>
//                                     <tr>
//                                         <th>Unit</th>
//                                         <th>Date</th>
//                                         <th>Price</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {item.data.map((data, index) => (
//                                         <tr key={index}>
//                                             <td>{data.unit}</td>
//                                             <td>{dateFormat(data.date)}</td>
//                                             <td>{data.price}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     ))}
//                 </div>
//             ))}
//         </div>
//     );
// }

// MORE ACCURATE BUT NEEDS TO HAVE A ROWSPAN IN UNIT COL
// import { Modal, Table } from "react-bootstrap";
// import ReactLoading from "react-loading";
// import { SyncLoader } from "react-spinners";
// import { dateFormat } from "../../Helpers/Utils/Common";

// export default function SupplierPriceTable(props) {
//     // Group data by supplier, item, and price
//     const suppliers = {};
//     props.tableData?.forEach(item => {
//         if (!suppliers[item.supplier]) {
//             suppliers[item.supplier] = [];
//         }

//         const existingItem = suppliers[item.supplier].find(existingItem => existingItem.name === item.name);
//         if (existingItem) {
//             existingItem.data.push({ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name });
//         } else {
//             suppliers[item.supplier].push({
//                 name: item.name,
//                 data: [{ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name }]
//             });
//         }
//     });

//     return props.showLoader ? (
//         <div className="d-flex justify-content-center my-5">
//             <SyncLoader color="var(--primary-color)" size={15} />
//         </div>
//     ) : (
//         <div>
//             {Object.keys(suppliers)?.map(supplier => (
//                 <div key={supplier}>
//                     {/* <h6>{supplier}</h6> */}
//                     {suppliers[supplier]?.map((item, index) => (
//                         <div key={index}>
//                             <Table>
//                                 <thead>
//                                     <tr>
//                                         {/* <th colSpan="3">{supplier}</th> */}
//                                     </tr>
//                                     <tr>
//                                         <th colSpan={2}>{supplier}</th>
//                                         {/* <th>Date</th> */}
//                                         <th>{item.name}</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {item.data.map((data, index) => (
//                                         <tr key={index}>
//                                             <td>{data.unit}</td>
//                                             <td>{dateFormat(data.date)}</td>
//                                             <td>{data.price}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     ))}
//                 </div>
//             ))}
//         </div>
//     );
// }


// ACCURATE BUT NEEDS UNIT GROUPING
// import { Modal, Table } from "react-bootstrap";
// import ReactLoading from "react-loading";
// import { SyncLoader } from "react-spinners";
// import { dateFormat } from "../../Helpers/Utils/Common";

// export default function SupplierPriceTable(props) {
//     // Group data by supplier, item, and price
//     const suppliers = {};
//     props.tableData?.forEach(item => {
//         if (!suppliers[item.supplier]) {
//             suppliers[item.supplier] = [];
//         }

//         const existingItem = suppliers[item.supplier].find(existingItem => existingItem.name === item.name);
//         if (existingItem) {
//             existingItem.data.push({ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name });
//         } else {
//             suppliers[item.supplier].push({
//                 name: item.name,
//                 data: [{ unit: item.unit, date: item.added_on, price: item.price, item_name: item.name }]
//             });
//         }
//     });

//     console.log(suppliers)

//     return props.showLoader ? (
//         <div className="d-flex justify-content-center my-5">
//             <SyncLoader color="var(--primary-color)" size={15} />
//         </div>
//     ) : (
//         <div>
//             {Object.keys(suppliers)?.map(supplier => (
//                 <div key={supplier}>
//                     {suppliers[supplier]?.map((item, index) => (
//                         <div key={index}>
//                             <Table>
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2}>{supplier}</th>
//                                         <th>{item.name}</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {item.data.map((data, index) => (
//                                         <tr key={index}>
//                                             {index === 0 && (
                                                
//                                                 <td rowSpan={item.data.length}>{data.unit}</td>
//                                             )}
//                                             <td>{dateFormat(data.date)}</td>
//                                             <td>{data.price}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     ))}
//                 </div>
//             ))}
//         </div>
//     );
// }

import { Modal, Table } from "react-bootstrap";
import ReactLoading from "react-loading";
import { SyncLoader } from "react-spinners";
import { dateFormat } from "../../Helpers/Utils/Common";

export default function SupplierPriceTable(props) {
    // Group data by supplier, item, and price
    const suppliers = {};
    props.tableData?.forEach(item => {
        if (!suppliers[item.supplier]) {
            suppliers[item.supplier] = {};
        }

        if (!suppliers[item.supplier][item.name]) {
            suppliers[item.supplier][item.name] = {};
        }

        if (!suppliers[item.supplier][item.name][item.unit]) {
            suppliers[item.supplier][item.name][item.unit] = [];
        }

        suppliers[item.supplier][item.name][item.unit].push({ date: item.added_on, price: item.price });
    });

    console.log(suppliers);

    return props.showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <div>
            {Object.keys(suppliers)?.map(supplier => (
                <div key={supplier}>
                    {Object.keys(suppliers[supplier])?.map(item => (
                        <div key={item}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>{supplier}</th>
                                        <th>{item}</th>
                                    </tr>
                                    {/* <tr>
                                        <th>Unit</th>
                                        <th>Date</th>
                                        <th>Price</th>
                                    </tr> */}
                                </thead>
                                <tbody>
                                    {Object.keys(suppliers[supplier][item])?.map(unit => (
                                        suppliers[supplier][item][unit].map((data, index) => (
                                            <tr key={index} className="req-table-w-border-top req-table-w-border-bottom">
                                                {index === 0 && (
                                                    <td 
                                                        rowSpan={suppliers[supplier][item][unit].length}
                                                        className="req-table-w-border-sides"
                                                    >
                                                        {unit
                                                    }</td>
                                                )}
                                                <td className="req-table-w-border-sides">{dateFormat(data.date)}</td>
                                                <td className="req-table-w-border-sides">{data.price}</td>
                                            </tr>
                                        ))
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
